import Axios from "axios";
let request = {};

function createRequest(method, url, data, opt, getRes) {
  let option = { header: opt.header, url };
  if (method === "get") option.params = data;
  else option = data;
  let instance = Axios.create({ baseURL: opt.baseUrl, ...opt.axiosConf });
  instance.interceptors.response.use(
    (res, config) => {
      let _data = res.data;
      let code = _data.code / 1;
      if (code === 0 || code === 200) return getRes ? _data : _data.data;
      else return Promise.reject(_data);
    },
    (error) => {
      console.log("request error", error);
      return Promise.reject(error);
    }
  );
  return instance[method](url, option);
}

request.get = function (url, data = {}, opt = {}) {
  return createRequest("get", url, data, opt);
};

request.post = function (url, data = {}, opt = {}) {
  return createRequest("post", url, data, opt);
};

request.raw = function (method, url, data = {}, opt = {}) {
  return createRequest(method, url, data, opt, true);
};
export default request;
